module.exports = "<div [innerHTML]=\"cguText | safeHtml\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/conditions-generales/cgu.component.html
// module id = 836
// module chunks = 0